
export default function Navigation() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-indigo-600" style={{ fontFamily: '"Pacifico", serif' }}>
              DUO FORM
            </span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2 bg-indigo-600 text-white rounded-full hover:bg-indigo-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact Us
            </button>
          </div>
          <button className="md:hidden text-gray-700 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
